import React from 'react';
import cx from 'classnames';
import { Icon } from 'js/components';
import {
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/pro-solid-svg-icons';

const ARROW_ICONS = {
  left: faChevronLeft,
  right: faChevronRight,
};

const SquadScorecardScrollArrow = ({ direction, onClick, visible, style }) => {
  if (!visible) {
    return null;
  }

  return (
    <div
      className={cx(
        'squad-scorecard-scroll-arrow',
        `squad-scorecard-scroll-arrow--${direction}`
      )}
      style={style}
    >
      <div
        className={cx(
          'squad-scorecard-scroll-gradient',
          `squad-scorecard-scroll-gradient--${direction}`
        )}
      />
      <button
        type="button"
        className="squad-scorecard-scroll-arrow-button"
        onClick={onClick}
        aria-label={direction === 'left' ? 'Scroll left' : 'Scroll right'}
      >
        <Icon icon={ARROW_ICONS[direction]} />
      </button>
    </div>
  );
};

export default SquadScorecardScrollArrow;
